import './Graphic.scss';
import React from 'react';
///home/cop/public_html/macread/macread-fe/src/app/images/struckaxiom.webp
import gridImage from '../../../images/grid_new.png';
import { Grid } from '@mui/material';
import { useAppSelector } from '../../../../reduxService/hooks';
import { useLocation } from 'react-router-dom';
import TireAndLayers from './TireAndLayers';

export const Graphic = () => {
    const location = useLocation();
    const inResults = location.pathname.split('/')[1] === 'results';

    const dynamicProject = useAppSelector(state => state.Dynamic.project);
    const currentProjectType = dynamicProject?.data?.type ?? 'container_yard';

    // Ottieni il valore di setStabilisedBallastThickness dai form fields del progetto
    const setStabilisedBallastThickness = (dynamicProject?.data?.formFields?.setStabilisedBallastThickness as number) ?? 0.2;

    return (
        <Grid container id="container" spacing={2} style={{ background: `repeat url(${gridImage})` }}>
            {!inResults && (
                <Grid
                    item
                    xs={12}
                    md={12}
                    id="canvas"
                    style={{
                        minHeight: '500px',
                        display: 'flex', // Usa flexbox
                        justifyContent: 'center', // Centra orizzontalmente
                        alignItems: 'center', // Centra verticalmente
                    }}>
                    <TireAndLayers projectType={currentProjectType} layerHeights={[60, 80, 100, 120]} differenziali={[0, 0, 0, 0]} setStabilisedBallastThickness={setStabilisedBallastThickness} />
                </Grid>
            )}
        </Grid>
    );
};

export default Graphic;
